import { faBuildingColumns } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Divider, Link, Stack } from '@mui/material'
import type { FC } from 'react'
import { Fragment } from 'react'

import type {
  IncomeType,
  KonfirIntegration,
  OpenBankingConnection,
} from '@/types/Activity'
import type { IncomeProperties } from '@/types/Income'

import KonfirPayroll from './KonfirPayroll'
import OpenBankingDetails from './OpenBankingDetails'
import { HeaderText } from './styles'

interface Props {
  openBankingConnections: OpenBankingConnection[]
  konfirIntegration?: KonfirIntegration | null
  incomeProperties: IncomeProperties
  incomeType: IncomeType
  isShortEmployment: boolean
  hasSingleIncome: boolean
  customerId: string
  subjectId: string
  onOpenRequests: () => void
}

const TrustedSources: FC<Props> = ({
  openBankingConnections,
  konfirIntegration,
  incomeProperties,
  incomeType,
  isShortEmployment,
  hasSingleIncome,
  customerId,
  subjectId,
  onOpenRequests,
}) => {
  const cards = [
    ...[...openBankingConnections]
      .reverse()
      .map((connection, connectionIndex) => (
        <OpenBankingDetails
          key={`${connection.source}-${connection.completedAt ?? connection.reportUrl}-${connectionIndex}`}
          openBanking={connection}
          incomeProperties={incomeProperties}
          incomeType={incomeType}
          isShortEmployment={isShortEmployment}
          hasSingleIncome={hasSingleIncome}
          customerId={customerId}
          subjectId={subjectId}
        />
      )),
    ...(konfirIntegration
      ? [
          <KonfirPayroll
            key="konfir"
            integration={konfirIntegration}
            isShortEmployment={isShortEmployment}
          />,
        ]
      : []),
  ]

  return (
    <Stack spacing={2.5}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <HeaderText variant="h6">Trusted Sources</HeaderText>
        <Link
          component="button"
          type="button"
          onClick={onOpenRequests}
          underline="none"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '14px',
            fontWeight: 600,
            color: '#082842',
          }}
        >
          <FontAwesomeIcon icon={faBuildingColumns} />
          Send Request
        </Link>
      </Box>
      {cards.map((card, index) => (
        <Fragment key={card.key ?? index}>
          {index > 0 && <Divider />}
          {card}
        </Fragment>
      ))}
    </Stack>
  )
}

export default TrustedSources
